import { InitLoadManagerRequestOptionsType } from '@mihanizm56/redux-core-modules';
import i18next from 'i18next';
import {
  setCoefficientsReportAction,
  setStartCoefficientsLoadingAction,
  setStopCoefficientsLoadingAction,
} from '@/pages/supplies-management/children/warehouses-limits/redux/warehouses-limits-module';
import { COMMON_TRANSLATIONS } from '@/pages/supplies-management/_constants/translations';
import { getAcceptanceCoefficientsRequestReport } from '@/api/requests/get-acceptance-coefficients-report';
import { getFormatterCoefficient } from '@/pages/supplies-management/children/warehouses-limits/store-inject-config/_utils/get-formatter-coefficient';
import { TConvertedCoefficientsTypeReport } from '@/pages/supplies-management/children/warehouses-limits/redux/warehouses-limits-module/types';
import { WAREHOUSES_FILTERS, WAREHOUSES_LIMITS_UP_TO_DAY } from '../_constants';
import { getFormattedFilteredCoefficientsReport } from './get-formatted-filtered-coefficients-report';

type TParams = {
  date?: Date;
  setReport: (params: TConvertedCoefficientsTypeReport) => void;
};

export const getCoefficientsReportConfig = ({
  date,
  setReport,
}: TParams): Array<InitLoadManagerRequestOptionsType> => {
  const dateFrom = date || new Date();
  const dateTo = new Date(
    dateFrom.getFullYear(),
    dateFrom.getMonth(),
    dateFrom.getDate() + WAREHOUSES_LIMITS_UP_TO_DAY,
  );

  return [
    {
      request: getAcceptanceCoefficientsRequestReport,
      requestOptions: {
        dateFrom,
        dateTo,
      },
      actionSuccess: setCoefficientsReportAction,
      showErrorNotification: true,
      titleMessageError: i18next.t(COMMON_TRANSLATIONS.error),
      loadingStartAction: setStartCoefficientsLoadingAction,
      loadingStopAction: setStopCoefficientsLoadingAction,
      responseDataFormatter: getFormatterCoefficient,
      callBackOnSuccess: (params) => {
        const filteredCoefficients = getFormattedFilteredCoefficientsReport(
          JSON.parse(localStorage.getItem(WAREHOUSES_FILTERS)),
          params.responseData.coefficientsReport,
        );
        setReport(filteredCoefficients);
      },
    },
  ];
};
